<template>
  <div>
    <div class="app-nav">
      <div class="row expanded">
        <div class="columns">
          <nav>
            <ul v-if="user">
              <li>
                <a href @click.prevent="addRequest">Add Request</a>
              </li>
              <li>
                <a href @click.prevent="doLogOut">Sign Out</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <main>
      <div class="row">
        <div class="columns">
          <!---->
          <!---->
          <div v-if="user">
            <div class="site-main small-24 columns medium-centered mainDiv">
              <h4>Hello, {{ user.name }}</h4>
              <form @submit.prevent="getDataByAddress">
                <div class="search">
                  <input
                    id="postSearch"
                    type="text"
                    name="postSearch"
                    v-model.lazy.trim="mainAddress"
                    placeholder="Type the Request Id or the Address"
                    class="search-field"
                  />
                  <input type="submit" value="submit" class="search-submit" />
                </div>
              </form>
              <grid
                :data="resultData"
                :columns="gridColumns"
                :classTable="sclass"
                @openModal="showModal"
              ></grid>
            </div>
            <div class="modal-backdrop" v-show="isModalVisible">
              <div class="modal">
                <header class="modal-header">
                  <slot name="header">
                    <p class="h2">{{ headerMessage }}</p>
                    <button
                      type="button"
                      class="btn-close"
                      @click.prevent="onCancel"
                    >
                      x
                    </button>
                  </slot>
                </header>
                <section class="modal-body">
                  <slot name="body">
                    <div id="style-guide">
                      <div id="form" class="mainDiv">
                        <form id="request">
                          <b>{{ messageStatus }}</b>
                          <!--<errors v-bind:notifications="msg"/>-->
                          <ul class="radioNoBullet">
                            <li v-for="group in errors.collect()">
                              <ul>
                                <li v-for="error in group">{{ error }}</li>
                              </ul>
                            </li>
                          </ul>
                          <div class="large-18 columns">
                            <label for="email">EMAIL</label>
                            <input
                              type="text"
                              id="email"
                              v-model.lazy.trim="email"
                              v-validate="'email'"
                              :class="{
                                'sg-input-error': errors.has('Email'),
                              }"
                              name="Email"
                              autocomplete="off"
                              :readonly="readOnly > 1"
                            />
                          </div>
                          <div class="large-6 columns">
                            <label for="phone">PHONE</label>
                            <input
                              id="phone"
                              name="Phone"
                              v-model.lazy.trim="phone"
                              v-validate="'min:10'"
                              maxlength="14"
                              type="text"
                              v-mask="'(###) ###-####'"
                              autocomplete="off"
                              :readonly="readOnly > 1"
                              :class="{
                                'sg-input-error': errors.has('Phone'),
                              }"
                            />
                          </div>
                          <div class="large-12 columns">
                            <label for="firstname">FIRSTNAME</label>
                            <input
                              id="firstname"
                              name="FirstName"
                              v-validate="'required'"
                              v-model.lazy.trim="firstName"
                              maxlength="50"
                              type="text"
                              autocomplete="off"
                              :readonly="readOnly > 1"
                              :class="{
                                'sg-input-error': errors.has('FirstName'),
                              }"
                            />
                          </div>
                          <div class="large-12 columns">
                            <label for="lastname">LASTNAME</label>
                            <input
                              id="lastname"
                              name="LastName"
                              v-validate="'required'"
                              v-model.lazy.trim="lastName"
                              maxlength="50"
                              type="text"
                              autocomplete="off"
                              :readonly="readOnly > 1"
                              :class="{
                                'sg-input-error': errors.has('LastName'),
                              }"
                            />
                          </div>
                          <div class="large-12 columns">
                            <label for="address">ADDRESS</label>
                            <input
                              id="address"
                              name="Address"
                              type="text"
                              v-model.lazy.trim="address"
                              v-validate="'required|vAddress'"
                              maxlength="100"
                              autocomplete="off"
                              :readonly="readOnly > 0"
                              :class="{
                                'sg-input-error': errors.has('Address'),
                              }"
                            />
                          </div>
                          <div class="large-6 columns">
                            <label for="unit">APT/UNIT</label>
                            <input
                              id="unit"
                              name="Unit"
                              v-model.lazy.trim="unit"
                              v-validate="isUnitRequired ? 'required' : ''"
                              maxlength="5"
                              type="text"
                              autocomplete="off"
                              :class="{
                                'sg-input-error': errors.has('Unit'),
                              }"
                            />
                          </div>
                          <div class="large-6 columns">
                            <label for="zipcode">ZIPCODE</label>
                            <input
                              id="zipcode"
                              name="ZipCode"
                              v-model.lazy.trim="zipCode"
                              v-validate="'required'"
                              maxlength="5"
                              type="text"
                              autocomplete="off"
                              readonly="readonly"
                              :class="{
                                'sg-input-error': errors.has('ZipCode'),
                              }"
                            />
                          </div>
                          <div class="large-42 columns">
                            <label>REASON</label>
                            <ul
                              class="radioNoBullet"
                              v-if="reasons && reasons.length"
                            >
                              <li
                                v-bind:key="reason.id"
                                v-for="reason of reasons"
                              >
                                <input
                                  type="radio"
                                  v-bind:value="reason.id"
                                  :id="'radio_' + reason.id"
                                  :disabled="readOnly > 1"
                                  v-model.lazy.trim="reasonSelected"
                                  v-validate="'required|included:1,2'"
                                  name="Reason"
                                />
                                <label :for="'radio_' + reason.id">{{
                                  reason.reason
                                }}</label>
                              </li>
                            </ul>
                            <br />
                          </div>
                          <div class="large-42 columns">
                            <input
                              type="checkbox"
                              v-bind:value="AddressChecked"
                              id="AddressChecked"
                              :disabled="readOnly > 1"
                              v-model.lazy.trim="AddressCheckedSelected"
                              v-validate="'required'"
                              name="AddressChecked"
                            />
                            <label for="AddressChecked"
                              >I have checked proof of address and residency in
                              Philadelphia.</label
                            ><br /><br /><br />
                          </div>
                          <div class="large-8 columns">
                            <label for="rfId">RFID (17 Digits)</label>
                            <input
                              id="rfId"
                              name="RFID"
                              v-model.lazy.trim="rfId"
                              v-validate="'min:17'"
                              maxlength="17"
                              type="text"
                              v-mask="'#################'"
                              autocomplete="off"
                              :readonly="readOnly > 1"
                              :class="{
                                'sg-input-error': errors.has('RFID'),
                              }"
                            />
                          </div>
                          <div class="large-8 columns">
                            <label for="pickupdate">PICKUP DATE</label>
                            <input
                              id="pickupdate"
                              name="pickupdate"
                              v-model.lazy.trim="pickupDate"
                              type="text"
                              v-validate="'required'"
                              readonly="readonly"
                              :class="{
                                'sg-input-error': errors.has('pickupdate'),
                              }"
                            />
                          </div>
                          <div class="large-8 columns">
                            <label for="pickuplocation">PICKUP LOCATION</label>
                            <select
                              id="pickuplocation"
                              name="PickupLocation"
                              v-model="pickupLocationId"
                              v-validate="{ is_not: 0 }"
                              :disabled="readOnly > 1"
                            >
                              <option v-bind:value="0">
                                Choose the pickup location
                              </option>
                              <option
                                v-for="option in pickupLocations"
                                v-bind:key="option.locId"
                                v-bind:value="option.locId"
                              >
                                {{ option.location }}
                              </option>
                            </select>
                          </div>
                        </form>
                      </div>
                    </div>
                  </slot>
                </section>
                <footer class="modal-footer">
                  <slot name="footer">
                    <!--<a @click="" class="button uniform-font">Close</a>-->
                    <div class="columns medium-6 end" v-if="!!showSubmit">
                      <br />
                      <p>
                        <a
                          href
                          :class="disabledClass"
                          @click.prevent="onSubmit(1)"
                          >SUBMIT</a
                        >
                      </p>
                    </div>
                    <div class="columns medium-6 end" v-else-if="!!showAddNew">
                      <br />
                      <p>
                        <a
                          href
                          class="button content-type-featured full"
                          @click.prevent="resetForm()"
                          >Add New</a
                        >
                      </p>
                    </div>
                    <div
                      class="columns medium-6 end"
                      v-if="newRequest === false && readOnly < 2"
                    >
                      <br />
                      <p>
                        <a
                          href
                          :class="disabledClass"
                          @click.prevent="onSubmit(2)"
                          >UPDATE</a
                        >
                      </p>
                    </div>
                    <div class="columns medium-6 end">
                      <br />
                      <p>
                        <a
                          href
                          class="button content-type-featured full"
                          @click.prevent="onCancel"
                          >BACK TO SEARCH</a
                        >
                      </p>
                    </div>
                  </slot>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import Grid from "../components/Grid";
import moment from "moment";

// Local Directive
import { mask } from "vue-the-mask";

export default {
  components: {
    Grid,
  },
  directives: {
    mask,
  },
  data() {
    return {
      gridData: [],
      gridColumns: ["Id", "Name", "Address", "Status", "Date", "Action"],
      sclass: "stack theme-light archive-results",
      mainAddress: "",
      firstName: "",
      lastName: "",
      address: "",
      unit: "",
      zipCode: "",
      email: "",
      phone: "",
      reason: false,
      rewards: false,
      philaCycle: false,
      reasons: [],
      msg: [],
      pickupLocations: [],
      reasonSelected: "1",
      AddressCheckedSelected: "",
      checked: false,
      pickupLocationId: 1,
      token: "",
      isModalVisible: false,
      isCompleted: false,
      requestId: "",
      rfId: "",
      createDate: "",
      isButtonDisabled: false,
      isNew: true,
      headerMessage: "Bin Registration",
      datePickup: "",
      fStatus: 0,
      msgStatus: "",
      userInfo: null,
      apiCallFailed: false,
      loginFailed: false,
      unitRequired: false,
      AddressChecked: false,
    };
  },
  created() {
    this.getFormData();
    this.addRequest();
  },
  methods: {
    getDataByAddress() {
      if (postSearch.value.length > 0) {
        this.gridData = [];
        axios
          .get(
            `${this.urlApi}/BinRequest/GetBinRequestsByAddress/${postSearch.value}`
          )
          .then((response) => {
            var tmpData = [];
            response.data.forEach((item) => {
              tmpData.push({
                Id: item.requestId,
                Name: item.firstName + " " + item.lastName,
                Address:
                  item.unit == ""
                    ? item.streetAddress
                    : item.streetAddress + ", APT/UNIT #" + item.unit,
                Status: item.statusID == 1 ? "Requested" : "Delivered",
                Date:
                  item.statusID == 1
                    ? moment(item.createDate).format("MM/DD/YYYY")
                    : moment(item.pickUpDate).format("MM/DD/YYYY"),
                Action: item.statusID == 1 ? "View/Edit" : "View",
              });
            });

            this.gridData = tmpData;
          })
          .catch((e) => {
            this.msg.push(e);
          });
      }
    },
    getDataById(Id) {
      axios
        .get(`${this.urlApi}/BinRequest/GetBinRequestById/${Id}`)
        .then((response) => {
          this.isNew = false;
          this.requestId = Id;
          this.firstName = response.data.firstName;
          this.lastName = response.data.lastName;
          this.address = response.data.streetAddress;
          this.unit = response.data.unit;
          this.zipCode = response.data.zipcode;
          this.email = response.data.email;
          this.phone = response.data.phone;
          this.reasonSelected = response.data.reasonID;
          this.createDate = response.data.createDate;

          if (response.data.statusID > 1) {
            this.rfId = response.data.rfid;
            this.pickupLocationId = response.data.pickupLocationID;
            this.datePickup = response.data.pickupDate;
          } else {
            this.rfId = "";
            this.pickupLocationId = 0;
            this.datePickup = "";
          }

          this.fStatus = response.data.statusID;
          this.$validator.reset();
        })
        .catch((e) => {
          this.msg.push(e);
        });
    },
    saveRequest() {
      //this.getToken();
      var self = this;
      if (self.rfId == "") {
        self.rfId = "10000000100000001";
      }

      this.$validator.validate().then((valid) => {
        if (valid) {
          self.isButtonDisabled = true;
          self.fStatus = 2;
          const formData = {
            FirstName: firstname.value,
            LastName: lastname.value,
            StreetAddress: address.value,
            Unit: unit.value,
            City: "Philadelphia",
            State: "PA",
            Zipcode: parseInt(zipcode.value),
            Email: email.value,
            Phone: phone.value,
            PickupDate: this.pickupDate,
            PickupLocationId: parseInt(pickuplocation.value),
            ReasonId: parseInt(this.reasonSelected),
            RFID: parseInt(rfId.value),
            StatusID: 2,
            CreateDate: new Date(),
            Username: this.user.userName,
          };

          axios({
            method: "POST",
            url: `${this.urlApi}/BinRequest/AddRequest`,
            data: JSON.stringify(formData),
          })
            .then(function (response) {
              if (response.data.status) {
                self.requestId = response.data.requestId;
                self.isCompleted = true;
                self.msgStatus = "Your request is saved successfully.";
                self.addNew = true;
              }
            })
            .catch(function (e) {
              //console.log(e);
              self.msg.push(e);
              self.msgStatus = "An error occurred. Please try again!";
            });
        }
      });
    },
    onUpdate() {
      var self = this;
      this.$validator.validate().then((valid) => {
        if (valid) {
          self.isButtonDisabled = true;
          self.fStatus = 2;
          const formData = {
            RequestId: parseInt(this.requestId),
            FirstName: firstname.value,
            LastName: lastname.value,
            StreetAddress: address.value,
            Unit: unit.value,
            City: "Philadelphia",
            State: "PA",
            Zipcode: parseInt(zipcode.value),
            Email: email.value,
            Phone: phone.value,
            PickupDate: this.pickupDate,
            PickupLocationId: parseInt(pickuplocation.value),
            ReasonId: parseInt(this.reasonSelected),
            RFID: parseInt(rfId.value),
            StatusID: 2,
            CreateDate: this.createDate,
            Username: this.user.userName,
          };
          axios({
            method: "PUT",
            url: `${this.urlApi}/BinRequest/UpdateRequest`,
            data: JSON.stringify(formData),
          })
            .then(function (response) {
              if (response.data.status) {
                self.isCompleted = true;

                self.msgStatus = "Request successfully updated.";
              } else {
              }
            })
            .catch(function (e) {
              self.msg.push(e);
              self.msgStatus = "An error occurred. Please try again!";
            });
        }
      });
    },
    onSubmit(data) {
      self = this;

      this.$validator.validate().then((valid) => {
        this.msgStatus = "";
        if (valid) {
          axios
            .get(
              `${this.urlApi}/BinRequest/CountBinRequestsByAddress/${address.value}/${unit.value}`
            )
            .then((response) => {
              // JSON responses are automatically parsed.
              if (response.data >= 1) {
                self.isModalVisible = true;

                self.msgStatus =
                  "We're sorry, Philadelphia households are limited two (2) bins every twelve months and one bin per visit. \
                   Please help reduce waste by repurposing any hard sided container under 32 Gallons and labeling it RECYCLING.";

                self.showModal();
              } else {
                if (data === 1) {
                  self.saveRequest();
                } else if (data === 2) {
                  self.onUpdate();
                }
              }
            })
            .catch((e) => {
              this.msg.push(e);
            });
        }
      });
    },
    onCancel() {
      this.reset();
    },
    VerifyAddress(vAddress) {
      this.zipCode = "";
      this.msgStatus = "";
      if (address.value != "") {
        var gateKeeperKey = this.aisGatekeeper;
        axios
          .get(`${this.urlAis}/${vAddress}${gateKeeperKey}`)
          .then((response) => {
            // JSON responses are automatically parsed.
            this.$store
              .dispatch("setAisAddress", response.data)
              .then((data) => {
                this.address = data.features[0].properties.street_address;
                this.zipCode = data.features[0].properties.zip_code;
                this.$store.dispatch("setIsAddressValid", true);
                this.AddressCheckedSelected = "1";
                var hasUnit = data.features.filter(
                  (e) => e.match_type.toLowerCase() == "unit_child"
                );

                if (hasUnit.length > 0) {
                  this.unitRequired = true;
                } else {
                  this.unitRequired = false;
                }
              });
          })
          .catch((e) => {
            this.$store.dispatch("setIsAddressValid", false);
            this.msg.push(e);
          });
      }
    },
    async doLogOut() {
      await this.$store.dispatch("login/logOut");
      document.location = this.$router.resolve({ name: "login" }).href;
    },
    reset() {
      (this.firstName = ""),
        (this.lastName = ""),
        (this.address = ""),
        (this.unit = ""),
        (this.zipCode = ""),
        (this.email = ""),
        (this.phone = ""),
        (this.reason = false),
        (this.msg = []),
        (this.reasonSelected = "1"),
        (this.checked = false),
        (this.pickupLocationId = 1),
        (this.isCompleted = false),
        (this.isModalVisible = false),
        (this.msgStatus = ""),
        (this.AddressCheckedSelected = ""),
        this.$store.dispatch("setIsAddressValid", false);
      this.rfId = "";
      this.isButtonDisabled = false;
      this.isNew = true;
      this.unitRequired = false;
      this.$validator.reset();
    },
    resetForm() {
      (this.firstName = ""),
        (this.lastName = ""),
        (this.address = ""),
        (this.unit = ""),
        (this.zipCode = ""),
        (this.email = ""),
        (this.phone = ""),
        (this.reason = false),
        (this.msg = []),
        (this.reasonSelected = "1"),
        (this.checked = false),
        (this.pickupLocationId = 1),
        (this.isCompleted = false),
        (this.isModalVisible = true),
        (this.msgStatus = ""),
        (this.AddressCheckedSelected = ""),
        (this.fStatus = 0);
      this.$store.dispatch("setIsAddressValid", false);
      this.rfId = "";
      this.isButtonDisabled = false;
      this.isNew = true;
      this.unitRequired = false;
      this.$validator.reset();
    },
    showModal(Id) {
      this.getDataById(Id);
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
      //this.reset();
    },
    addRequest() {
      this.fStatus = 0;
      this.reasonSelected = "1";
      this.pickupLocationId = 1;
      this.isModalVisible = true;
      this.isCompleted = false;
    },
    getFormData() {
      axios
        .all([
          axios.get(`${this.urlApi}/formData/GetPickupLocations`),
          axios.get(`${this.urlApi}/formData/GetRequestReasons`),
        ])
        .then(
          axios.spread((pickupLocations, reasons) => {
            (this.pickupLocations = pickupLocations.data),
              (this.reasons = reasons.data),
              this.$store.dispatch("setPickupLocation", pickupLocations.data),
              this.$store.dispatch("setReasons", reasons.data);
          })
        )
        .catch((e) => {
          this.msg.push(e);
        });
    },
    replace() {
      this.actionData = "";
    },
  },
  computed: {
    resultData() {
      return this.gridData;
    },
    showAddNew() {
      var result = false;
      if (this.newRequest && this.isCompleted) {
        result = true;
      } else {
        result = false;
      }
      return result;
    },
    showSubmit() {
      var result = false;
      if (this.newRequest && this.readOnly < 1 && !this.isCompleted) {
        result = true;
      } else {
        result = false;
      }
      return result;
    },
    pickupDate() {
      let aDate = "";

      aDate = moment(new Date()).format("MM/DD/YYYY");

      if (this.readOnly > 1) {
        aDate =
          this.datePickup == ""
            ? moment(new Date()).format("MM/DD/YYYY")
            : moment(this.datePickup).format("MM/DD/YYYY");
      }
      return aDate;
    },
    disabledClass() {
      return this.isButtonDisabled
        ? "button content-type-featured full disabled"
        : "button content-type-featured full";
    },
    newRequest() {
      return this.isNew;
    },
    readOnly(fStatus) {
      return this.fStatus;
    },
    messageStatus() {
      return this.msgStatus;
    },
    user() {
      return this.$store.state.login.myMSALObj.account;
    },
    urlApi() {
      return this.$store.state.appconfig.urlApi;
    },
    urlAis() {
      return this.$store.state.appconfig.urlAis;
    },
    aisGatekeeper() {
      return this.$store.state.appconfig.aisGatekeeper;
    },
    isUnitRequired() {
      return this.unitRequired;
    },
  },
  watch: {
    address(val) {
      if (this.newRequest) {
        if (val != "") {
          this.VerifyAddress(val);
        }
      } else {
        this.$store.dispatch("setIsAddressValid", true);
      }
    },
  },
};
</script>

<style scoped>
.mainDiv {
  padding-top: 50px;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  border-top: 10px solid #0f4d90;
  width: 70%;
  height: 90%;
}

.modal-header,
.modal-footer {
  padding: 10px;
  display: flex;
}

.modal-header {
  border-bottom: 1px solid #eeeeee;
  color: #2176d2;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
  text-align: left;
}

.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #0f4d90;
  background: transparent;
}
.disabled {
  cursor: not-allowed;
  color: gray;
  pointer-events: none;
}
.radioNoBullet {
  list-style: none;
  margin: 0;
  padding: 0;
}

.mainDiv {
  padding-top: 20px;
}

.defaultHeight {
  padding-bottom: 250px;
}
.divx {
  font-size: 13px;
  color: black;
}

@media print {
  /*a[href]:after {
            display: none;
            visibility: hidden;
    }*/
  .noprint {
    display: none;
    visibility: hidden;
  }
}
</style>
